import React from 'react';
import {
  Card,
  CardBody,
  VStack,
  HStack,
  Text,
  Icon,
  Badge,
  Progress,
  useColorModeValue
} from '@chakra-ui/react';
import { FiTarget } from 'react-icons/fi';
import { useTranslation } from 'react-i18next';

interface ProgressCardProps {
  selectedWordsCount: number;
  progressPercentage: number;
}

const ProgressCard: React.FC<ProgressCardProps> = ({
  selectedWordsCount,
  progressPercentage
}) => {
  const { t } = useTranslation();

  const cardBg = useColorModeValue('white', 'gray.800');
  const textColor = useColorModeValue('gray.800', 'white');
  const mutedTextColor = useColorModeValue('gray.600', 'gray.300');
  const accentColor = useColorModeValue('blue.500', 'blue.400');
  const successColor = useColorModeValue('green.500', 'green.400');

  return (
    <Card bg={cardBg} shadow="2xl" borderRadius="3xl" border="2px" borderColor={accentColor}>
      <CardBody p={6}>
        <VStack spacing={4}>
          <HStack justify="space-between" w="full">
            <HStack spacing={3}>
              <Icon as={FiTarget} color={accentColor} fontSize="xl" />
              <Text fontSize="lg" fontWeight="bold" color={textColor}>
                {t('onboarding.vocabulary.progress')}
              </Text>
            </HStack>
            <Badge
              colorScheme="blue"
              variant="subtle"
              borderRadius="full"
              px={4}
              py={2}
              fontSize="sm"
            >
              {selectedWordsCount} {t('onboarding.vocabulary.selected')}
            </Badge>
          </HStack>

          <Progress
            value={progressPercentage}
            size="lg"
            borderRadius="full"
            bg={useColorModeValue('gray.200', 'gray.700')}
            sx={{
              '& > div': {
                background: `linear-gradient(90deg, ${accentColor}, ${successColor})`,
              }
            }}
            w="full"
          />

          <HStack justify="space-between" w="full">
            <Text fontSize="sm" color={mutedTextColor}>
              {Math.round(progressPercentage)}% {t('onboarding.vocabulary.complete')}
            </Text>
            <Text fontSize="sm" color={accentColor} fontWeight="medium">
              {t('onboarding.vocabulary.targetWords')}
            </Text>
          </HStack>
        </VStack>
      </CardBody>
    </Card>
  );
};

export default ProgressCard;